import React from 'react';

const DateTimeInput = ({ id, label, value, onChange, error, required=true, disabled=false, stepMinutes=1, min, max, dateOnly=false }) => {
  return (
    <div className="mb-4">
      <div className='flex'>
        <label htmlFor={id} className="block text-sm font-medium text-gray-700">
          {label}
        </label>
        {required ? (
          <label className='text-red-500'> *</label>
        ) : null}
      </div>
      
      <input
        id={id}
        type={dateOnly ? "date" : "datetime-local"}
        value={value}
        disabled={disabled}
        min={min}
        max={max}
        step={dateOnly ? undefined : stepMinutes * 60}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full px-2 py-1.5 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 border-gray-300`}
        required
      />

      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default DateTimeInput;